import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef, useEffect } from "react";
import apiResponse from "../../../../services/apiResponse";
import classnames from "classnames";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Spinner,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import moment from "moment";
import { Link } from "react-router-dom";

import Select from "../../../../helpers/ui/CustomSelect";
import { MonthSelect, YearSelect } from "../../../../helpers/ui/YearSelect";

import DetailBloc from "./Blocs/DetailBloc";
//import TableComponent from "./Component/TableComponent";
import JobTreeComponent from "./Component/JobTreeComponent";
import ChartComponent from "./Component/ChartComponent";
import UnorComponent from "./Component/UnorComponent";
import InfoJabatanComponent from "./Component/InfoJabatanComponent";
import TableComponentNew from "./Component/TableComponentNew";
import ResumeComponent from "./Component/ResumeComponent";


const HierarchicalSelect = (props) => {
    const getMonthName = (month) => {
      const monthNames = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      return month >= 1 && month <= 12 ? monthNames[month - 1] : "";
    };
  const monthAlphabet = getMonthName(props.month);
  const [activeTab, setactiveTab] = useState(
    sessionStorage.getItem("indexPetaJabatan")
      ? sessionStorage.getItem("indexPetaJabatan")
      : "1"
  );
  const [currentUuid, setcurrentUuid] = useState(null);
  const [currentPositionUuid, setCurrentPositionUuid] = useState(null);
  const [currentType, setCurrentType] = useState(null);

  const firstTab = useRef();
  const secondTab = useRef();
  const thirdTab = useRef();
  const fourthTab = useRef();
  const fiveTab = useRef();

  const reloadFirstTab = () => firstTab.current.setTokenAPI();
  const reloadSecondTab = () => secondTab.current.setTokenAPI();
  const reloadThirdTab = () => thirdTab.current.setTokenAPI();
  const reloadFourthTab = () => fourthTab.current.setTokenAPI();
  const reloadFiveTab = () => fiveTab.current.setTokenAPI();

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab);
      sessionStorage.setItem("indexPetaJabatan", tab);
    }
  }


const handleSelectUuid = (data) => {
  setCurrentType(data.type);
  if (data.type === "position") {
    setCurrentPositionUuid(data.positionUuid);
    setcurrentUuid(data.workUnitUuid);
  } else {
    setcurrentUuid(data.workUnitUuid);
    setCurrentPositionUuid(null);
  }
};

  return (
    <Fragment>
        {/* <Container fluid> */}
          <Row>
            <Col className="col-12">
              <Card className="petajabatan-leftbar">
                <Row className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-muted">Periode</span>
                    <span className="fw-semibold">
                       {monthAlphabet} {props.year}
                    </span>
                  </div>
                </Row>
              <JobTreeComponent onSelectUuid={handleSelectUuid}/>
              </Card>

              <Card className="petajabatan-rightbar">
              <CardBody>
                                <hr />
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-none d-sm-block">Struktur Jabatan</span>                                            
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                          <span className="d-none d-sm-block">Data Unor</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "3",
                                                })}
                                            onClick={() => {
                                                toggle("3")
                                            }}
                                        >
                                          <span className="d-none d-sm-block">Info Jabatan</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "4",
                                                })}
                                            onClick={() => {
                                                toggle("4")
                                            }}
                                        >
                                          <span className="d-none d-sm-block">Data Pegawai ASN</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "5",
                                                })}
                                            onClick={() => {
                                                toggle("5")
                                            }}
                                        >
                                          <span className="d-none d-sm-block">Resume</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <ChartComponent ref={firstTab} uuid= {currentUuid} handleChartSuccess={reloadFirstTab}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <UnorComponent ref={secondTab} work_unit={currentUuid} position_uuid={currentPositionUuid} periode={props.uuid} handleChartSuccess={reloadSecondTab}/>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <InfoJabatanComponent ref={thirdTab} work_unit={currentUuid} position_uuid={currentPositionUuid} periode={props.uuid} handleChartSuccess={reloadThirdTab}/>
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <TableComponentNew ref={fourthTab} work_unit={currentUuid} position_uuid={currentPositionUuid} periode={props.uuid} handleChartSuccess={reloadFourthTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId="5">
                                        <ResumeComponent ref={fiveTab} work_unit={currentUuid} position_uuid={currentPositionUuid} periode={props.uuid} handleChartSuccess={reloadFiveTab}
                                        />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
              </Card>
            </Col>
          </Row>
        {/* </Container> */}
      </Fragment>
  );
};

export default HierarchicalSelect;
